import { Controller } from "@hotwired/stimulus";
import { Model } from "survey-core";
import { renderSurvey } from "survey-js-ui";

import surveySetup from "./form_functions/surveySetup";
import addNavigation from "./form_functions/addNavigation";

export default class extends Controller {
  static values = {
    formData: { type: Object, default: {} },
    isAdmin: { type: Boolean, default: false },
    defaultResponse: { type: Object, default: {} },
    responseData: { type: Object, default: {} },
    state: { type: String, default: "" },
    responseUrl: { type: String, default: "" },
    completeUrl: { type: String, default: "" },
    uploadUrl: { type: String, default: "" },
    documentsUrl: { type: String, default: "" },
    checkSubmittedUrl: { type: String, default: "" },
    requiredWaDocuments: { type: Array, default: [] },
  };

  static targets = ["surveyContainer"];

  connect() {
    const surveyModel = new Model(this.formDataValue);

    const config = {
      responseData: this.responseDataValue,
      state: this.stateValue,
      defaultResponse: this.defaultResponseValue,
      urls: {
        response: this.responseUrlValue,
        complete: this.completeUrlValue,
        upload: this.uploadUrlValue,
        documents: this.documentsUrlValue,
        checkSubmitted: this.checkSubmittedUrlValue,
      },
      requiredWaDocuments: this.requiredWaDocumentsValue,
    };

    surveySetup(surveyModel, config);

    renderSurvey(surveyModel, this.surveyContainerTarget);

    addNavigation(surveyModel);

    this.addEventListeners();
  }

  addEventListeners() {
    if (this.isAdminValue) {
      window.addEventListener("beforeunload", this.beforeUnloadHandler);
    }
  }

  beforeUnloadHandler(event) {
    event.preventDefault();
    event.returnValue = true;
  }
}
